// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__md3bw","dragIcon":"SortableItem_dragIcon__6f8dA","disabled":"SortableItem_disabled__TbKSR"};